// Define a constant for milliseconds
const TEN_SECONDS_MS = 10000;
const FIVE_SECONDS_MS = 5000;
const THREE_SECONDS_MS = 3000;

// Export timeout durations for API calls
export const ApiTimeouts = {
  DEFAULT_TIMEOUT: TEN_SECONDS_MS,
  GET_LISTING: TEN_SECONDS_MS, // Timeout for the "Get Listing" API in milliseconds
  GO_SEARCH_PROPERTY: THREE_SECONDS_MS, // Tight timeout for go-search property fetch; V3 fallback kicks in on expiry
  RECAPTCHA_TOKEN_GENERATION: FIVE_SECONDS_MS, // Timeout for reCAPTCHA token generation
};
